import { useState } from "react";
import "./style.scss";
import { Button, Popover } from "antd";
import moment from "moment";
import RangePickerCustom from "./RangePickerCustom";

const dateFormat = "MM/DD/YYYY";
const ButtonRangePicker = ({ onFilter, showIcon = false }) => {
  const today = new Date();
  const [open, setOpen] = useState(false);
  const [dates, setDates] = useState({
    startDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
    endDate: today,
    key: "selection",
  });

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleSelectedDates = (dates) => {
    setDates(dates);
    onFilter(dates);
    setOpen(false);
  };

  return (
    <Popover
      trigger={["click"]}
      open={open}
      onOpenChange={handleOpenChange}
      content={
        <RangePickerCustom onSubmit={handleSelectedDates} values={dates} />
      }
      overlayClassName="popupPicker"
    >
      {showIcon ? (
        <svg
          width="19"
          height="11"
          viewBox="0 0 19 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.890625 0H18.1094C18.3456 0 18.5721 0.091494 18.7391 0.254355C18.9062 0.417215 19 0.638101 19 0.868421C19 1.09874 18.9062 1.31963 18.7391 1.48249C18.5721 1.64535 18.3456 1.73684 18.1094 1.73684H0.890625C0.654417 1.73684 0.427883 1.64535 0.260858 1.48249C0.0938334 1.31963 0 1.09874 0 0.868421C0 0.638101 0.0938334 0.417215 0.260858 0.254355C0.427883 0.091494 0.654417 0 0.890625 0ZM3.5625 5.5C3.5625 5.26968 3.65633 5.04879 3.82336 4.88593C3.99038 4.72307 4.21692 4.63158 4.45312 4.63158H14.5469C14.7831 4.63158 15.0096 4.72307 15.1766 4.88593C15.3437 5.04879 15.4375 5.26968 15.4375 5.5C15.4375 5.73032 15.3437 5.95121 15.1766 6.11407C15.0096 6.27693 14.7831 6.36842 14.5469 6.36842H4.45312C4.21692 6.36842 3.99038 6.27693 3.82336 6.11407C3.65633 5.95121 3.5625 5.73032 3.5625 5.5ZM7.125 10.1316C7.125 9.90126 7.21883 9.68037 7.38586 9.51751C7.55288 9.35465 7.77942 9.26316 8.01562 9.26316H10.9844C11.2206 9.26316 11.4471 9.35465 11.6141 9.51751C11.7812 9.68037 11.875 9.90126 11.875 10.1316C11.875 10.3619 11.7812 10.5828 11.6141 10.7456C11.4471 10.9085 11.2206 11 10.9844 11H8.01562C7.77942 11 7.55288 10.9085 7.38586 10.7456C7.21883 10.5828 7.125 10.3619 7.125 10.1316Z"
            fill="black"
          />
        </svg>
      ) : (
        <Button className="btnCalendar">
          <span className="dates">
            {(dates &&
              dates.startDate &&
              moment(dates.startDate).format(dateFormat)) ||
              ""}{" "}
            -{" "}
            {(dates &&
              dates.endDate &&
              moment(dates.endDate).format(dateFormat)) ||
              ""}
          </span>{" "}
          <svg
            className="iconCalendar"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.1536 1.87444H16.4453V0.62444C16.4454 0.45868 16.3797 0.299665 16.2625 0.182376C16.1454 0.0650881 15.9865 -0.000865907 15.8207 -0.000976414C15.655 -0.00108692 15.496 0.0646551 15.3787 0.181787C15.2614 0.298919 15.1954 0.457847 15.1953 0.623607V1.87444H11.4453V0.62444C11.4454 0.542364 11.4293 0.461081 11.3979 0.385231C11.3665 0.309382 11.3205 0.240452 11.2625 0.182376C11.2046 0.124301 11.1357 0.0782181 11.0599 0.0467583C10.9841 0.0152986 10.9028 -0.000921706 10.8207 -0.000976423C10.655 -0.00108693 10.496 0.0646551 10.3787 0.181787C10.2614 0.298919 10.1954 0.457847 10.1953 0.623607V1.87444H6.44531V0.62444C6.44537 0.542364 6.42926 0.461081 6.3979 0.385231C6.36654 0.309382 6.32055 0.240452 6.26255 0.182376C6.20455 0.124301 6.13568 0.0782181 6.05987 0.0467583C5.98407 0.0152986 5.90281 -0.000921706 5.82073 -0.000976423C5.65497 -0.00108693 5.49595 0.0646551 5.37867 0.181787C5.26138 0.298919 5.19542 0.457847 5.19531 0.623607V1.87444H2.48698C2.0451 1.87444 1.6213 2.04992 1.30876 2.3623C0.996226 2.67468 0.820533 3.09839 0.820312 3.54027V18.3319C0.820313 18.774 0.995907 19.1979 1.30847 19.5105C1.62103 19.823 2.04495 19.9986 2.48698 19.9986H19.1536C19.5957 19.9986 20.0196 19.823 20.3322 19.5105C20.6447 19.1979 20.8203 18.774 20.8203 18.3319V3.54027C20.8201 3.09839 20.6444 2.67468 20.3319 2.3623C20.0193 2.04992 19.5955 1.87444 19.1536 1.87444ZM19.5703 18.3328C19.5703 18.4431 19.5265 18.549 19.4486 18.6271C19.3706 18.7052 19.2648 18.7492 19.1545 18.7494H2.48698C2.37647 18.7494 2.27049 18.7055 2.19235 18.6274C2.11421 18.5493 2.07031 18.4433 2.07031 18.3328V3.54111C2.07053 3.43074 2.11453 3.32498 2.19265 3.24702C2.27076 3.16906 2.37662 3.12527 2.48698 3.12527H5.19531V4.37527C5.1952 4.54103 5.26094 4.70005 5.37808 4.81734C5.49521 4.93463 5.65414 5.00058 5.8199 5.00069C5.98566 5.0008 6.14467 4.93506 6.26196 4.81793C6.37925 4.70079 6.4452 4.54187 6.44531 4.37611V3.12527H10.1953V4.37527C10.1952 4.54103 10.2609 4.70005 10.3781 4.81734C10.4952 4.93463 10.6541 5.00058 10.8199 5.00069C10.9857 5.0008 11.1447 4.93506 11.262 4.81793C11.3792 4.70079 11.4452 4.54187 11.4453 4.37611V3.12527H15.1953V4.37527C15.1952 4.54103 15.2609 4.70005 15.3781 4.81734C15.4952 4.93463 15.6541 5.00058 15.8199 5.00069C15.9857 5.0008 16.1447 4.93506 16.262 4.81793C16.3792 4.70079 16.4452 4.54187 16.4453 4.37611V3.12527H19.1536C19.2639 3.12549 19.3695 3.16938 19.4474 3.24731C19.5254 3.32525 19.5693 3.43089 19.5695 3.54111L19.5703 18.3328Z"
              fill="#999999"
            />
            <path
              d="M5.19531 7.5H7.69531V9.375H5.19531V7.5ZM5.19531 10.625H7.69531V12.5H5.19531V10.625ZM5.19531 13.75H7.69531V15.625H5.19531V13.75ZM9.57031 13.75H12.0703V15.625H9.57031V13.75ZM9.57031 10.625H12.0703V12.5H9.57031V10.625ZM9.57031 7.5H12.0703V9.375H9.57031V7.5ZM13.9453 13.75H16.4453V15.625H13.9453V13.75ZM13.9453 10.625H16.4453V12.5H13.9453V10.625ZM13.9453 7.5H16.4453V9.375H13.9453V7.5Z"
              fill="#999999"
            />
          </svg>
        </Button>
      )}
    </Popover>
  );
};

export default ButtonRangePicker;
